<app-horizontal-scroll>

  <div class="hg-container">
      
    <div class="hg-item-container" *ngFor="let image of images; let i = index" (click)="activateFullscreen(i)">

      <img alt="" class="hg-item-image" [src]="image">

    </div>
  
  </div>

</app-horizontal-scroll>